
export function cleanPtags(title) {

    var title_nop = title.replace("<p>", "")
    return title_nop.replace("</p>", "")

}
export function createSlug(title) {

    title = String(title).toLowerCase()
    title = title.replaceAll(".", "")
    title = title.replaceAll(" ", "-")
    title = title.replaceAll("ü", "ue")
    title = title.replaceAll("ä", "ae")
    title = title.replaceAll("ö", "oe")

    return title.replaceAll(" ", "-")

}

export function phoneNumberUrl(phone) {

    phone = phone.replace(/\s/g, "")
    phone = phone.replace("-", "")
    phone = phone.replace("+", "")
    phone = phone.replace("/", "")
    while(phone.charAt(0) === '0') {
        phone = phone.substring(1);
    }
    return 'tel:+43' + phone

}

export function randomIntFromInterval(min, max) {

    return Math.floor(Math.random() * (max - min + 1) + min)

}

export function scrollDiv(id, direction, columns = 3) {

    const scrollableDiv = document.getElementById(id)
    const scrollableDivWidth = scrollableDiv.scrollWidth / columns

    if(direction === 'left') {
      if(scrollableDiv.scrollLeft === 0) {
         scrollableDiv.scrollLeft = scrollableDiv.scrollWidth
      } else {
         scrollableDiv.scrollLeft -= scrollableDivWidth;
      }
    } else if(direction === 'right') {
        if(scrollableDiv.offsetWidth + scrollableDiv.scrollLeft === scrollableDiv.scrollWidth) {
            scrollableDiv.scrollLeft = 0
        } else {
            scrollableDiv.scrollLeft += scrollableDivWidth;
        }
    }

}

export function scrollToGroup(id, offset) {

  const yOffset = offset;
  const element = document.getElementById(id);
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({top: y, behavior: 'smooth'});

}

export function stripTags(string) {

    return string.replace(/(<([^>]+)>)/ig, '')

}

export function webp(srcSet) {

   srcSet = srcSet.replaceAll(".jpg ", ".jpg.webp ")
   srcSet = srcSet.replaceAll(".jpeg ", ".jpeg.webp ")
   srcSet = srcSet.replaceAll(".png ", ".png.webp ")
   srcSet = srcSet.replaceAll(".gif ", ".gif.webp ")

   return srcSet

}
